jQuery(function ($) {
  function toggleHeaders() {
    var header1 = $(".site-header-1");
    var header2 = $(".site-header-2");
    var isLargeScreen = window.matchMedia("(min-width: 1280px)").matches;

    if (isLargeScreen) {
      var header1Height = header1.outerHeight() - 50;
      var header1Offset = header1.offset().top;
      var scrollTop = $(window).scrollTop();

      if (scrollTop > header1Offset + header1Height) {
        header1.addClass("hidden");
        header2.removeClass("hidden");
      } else {
        header1.removeClass("hidden");
        header2.addClass("hidden");
      }
    } else {
      header1.addClass("hidden");
      header2.removeClass("hidden"); // Hide header-2 on small screens
    }
  }

  $(window).on("scroll resize", toggleHeaders);
  toggleHeaders(); // Initial call to set header visibility on page load

  var currentPath = window.location.pathname;

  $(".menu-item").each(function () {
    var menuItemLink = $(this).find("a");
    var menuItemPath = menuItemLink.attr("href");

    if (currentPath === menuItemPath) {
      $(this).addClass("is-active");
    }
  });


  //Function for Tab Focus Menu
  function lockFocus(e) {
    const isTabPressed = e.key === 'Tab' || e.keyCode === 9;

    if (!isTabPressed) {
      return;
    }

    e.preventDefault();

    if (focusableElements.length == 1) {
      focusableElements[0].trigger('focus');
    } else {
      console.log('focusableElementsCurrentIndex', focusableElementsCurrentIndex);
      if (e.shiftKey) {
        focusableElementsCurrentIndex--;

        if (focusableElementsCurrentIndex < 0) {
          focusableElementsCurrentIndex = focusableElements.length - 1;
        }

      } else {
        focusableElementsCurrentIndex++;

        if (focusableElementsCurrentIndex >= focusableElements.length) {
          focusableElementsCurrentIndex = 0;
        }
      }

      $.each(focusableElements, function () {
        $(this).removeClass('force-focus');
      });

      $(focusableElements[focusableElementsCurrentIndex]).trigger('focus');

      if ($(focusableElements[focusableElementsCurrentIndex]).is('a')) {
        $(focusableElements[focusableElementsCurrentIndex]).addClass('force-focus');
      }
    }
  }

  //Hamburger menu
  $("#menu-show").on("click", function () {
    $("#hamburger-menu").toggle();

    var hamburgerImg = $("#menu-show img");
    var menuText = $("#menu-show p");

    if ($("#hamburger-menu").is(":visible")) {

      // console.log('hamburg is visible')

      //add class to hamburgermenu
      $("#hamburger-menu").addClass('hamburgermenu-open');
      $('#hamburger-utilities').addClass('hamburger-utilities-visible');


      hamburgerImg.attr(
        "src",
        "themes/custom/tema/src/assets/icons/close-icon.svg"
      );
      menuText.text("SLUITEN");
      $("body").css("overflow", "hidden"); // Disable scrolling

      $("#menu-show").toggleClass("menu-btn-trigger menu-close");

      //fokus
      const target = $(this).data("target");
      console.log(target);
      focusableElements = [];

      focusableElements.push($(target).find(".menu-close"));

      $("#" + target + " button.menu-close").each(function () {
        focusableElements.push($(this));
      });

      $("#" + target + " .menu-item a").each(function () {
        focusableElements.push($(this));
      });

      $("#" + target + " .menu-login").each(function () {
        focusableElements.push($(this));
      });

      $("#" + target + " .menu-letter").each(function () {
        focusableElements.push($(this));
      });

      $("#" + target + " .menu-translate").each(function () {
        focusableElements.push($(this));
      });

      $("#" + target + " .menu-contrast").each(function () {
        focusableElements.push($(this));
      });

      console.log(focusableElements);
      focusableElementsCurrentIndex = -1;

      document.addEventListener("keydown", lockFocus);

    } else {

      $("#hamburger-menu").removeClass('hamburgermenu-open');
      $('#hamburger-utilities').removeClass('hamburger-utilities-visible');

      hamburgerImg.attr(
        "src",
        "themes/custom/tema/src/assets/icons/hamburger-menu.svg"
      );
      menuText.text("MENU");
      $("body").css("overflow", "auto"); // Enable scrolling

      $("#menu-show").toggleClass("menu-btn-trigger menu-close");

      //fokus
      document.removeEventListener("keydown", lockFocus);
    }
  });
  //END Hamburger menu

  //Contrast Button
  var themeToggleButtons = document.querySelectorAll(".theme-toggle-button");
  var htmlElement = document.documentElement;

  themeToggleButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      htmlElement.classList.toggle("dark");
      var isDarkMode = htmlElement.classList.contains("dark");
      // Store the dark mode state in localStorage
      localStorage.setItem("darkMode", isDarkMode);
    });
  });
  //END Contrast Button

  // Function to add <hr> after each menu item
  function addHrAfterMenuItems() {
    const container = document.getElementById("menu-hr-container");
    const menuItems = container.querySelectorAll(".menu-item");

    menuItems.forEach((menuItem) => {
      const hrElement = document.createElement("hr");
      menuItem.parentNode.insertBefore(hrElement, menuItem.nextSibling);
    });
  }

  // Call the function to add <hr> after menu items
  addHrAfterMenuItems();
});
